<template>
  <b-container v-if="this.$root.token">
    <b-row align-h="center">
      <b-col>
        <br>
        <h3>Import Survey</h3>
        <br>
      </b-col>
    </b-row>
    <b-row v-show="!saving" align-h="center">
      <b-col cols=6>
        <survey-run-selection v-model="surveyRun" :survey-run-id="this.$route.query.scoringEventId" @update:surveyRun="setSurveyRun($event)" :no-new="false"/>
      </b-col>
    </b-row>
    <b-row v-show="!saving && surveyRun" align-h="center">
      <b-col cols=6>
        <survey-selection v-model="fullsurvey" @update:survey="fullsurvey = $event"/>
      </b-col>
    </b-row>
    <b-row v-if="!this.saving" v-show="surveyRun && fullsurvey">
      <b-col>
        <question-table v-model="questions" v-if="fullsurvey" :survey="fullsurvey" @update:questions="updateQuestions($event)" :template="programmeTemplate"/>
      </b-col>
    </b-row>
    <b-row class="pt-3">
      <b-col>
        <b-button variant="success" @click="submitform" :disabled="isforminvalid">Submit</b-button>
      </b-col>
      <b-col v-show="isforminvalid && missingField">
        <b-alert show variant="danger">{{ missingField }} is missing</b-alert>
      </b-col>
      <b-col>
        <b-button to="/" variant="default">Cancel</b-button>
      </b-col>
    </b-row>
    <b-row v-if="this.saving">
      <h1>Saving....don't go anywhere.....</h1>
      <b-col>
        <font-awesome-icon icon="spinner" size="lg" spin/>
      </b-col>
    </b-row>
  </b-container>
</template>
<script>
// @ is an alias to /src
import SurveySelection from "@/components/SurveySelection.vue";
import SurveyRunSelection from "@/components/SurveyRunSelection.vue";
import QuestionTable from "@/components/QuestionTable.vue";
import * as API from "@/services/API";
import Joi from 'joi-browser';

export default {
  name: "Wizard",
  components: {
    SurveySelection,
    SurveyRunSelection,
    QuestionTable
  },
  data: function() {
    return {
      fullsurvey: null,
      surveyRun: null,
      questions: [],
      validform: false,
      missingField: '',
      saving: false,
      programmeTemplate: []
    }
  },
  computed: {
    isforminvalid: {
      get: function() {
        this.validateForm()
        return !this.validform
      },
      set: function(newValue) {
        this.validform = newValue
      }
    }
  },
  created() {
  },
  methods: {
    setSurveyRun: function (e) {
      this.surveyRun = e.surveyRun;
      if (e.surveyRun) {
        this.programmeTemplate = JSON.parse(e.surveyRun.programme.template) || [];
      }
    },
    validateForm: function() {
      // schema
      const schema = Joi.object({
        ScoringEvent: Joi.object().required(),
        Survey: Joi.object().required(),
        Questions: Joi.array().min(1).items(Joi.object({
          "Topic/Element Name": Joi.string().min(1).required()
        })).required()
      });
      var that = this;

      //object to validate
      Joi.validate(
        {
          Survey: this.fullsurvey,
          ScoringEvent: this.surveyRun,
          Questions: (this.questions || []).map(question => {
            return {"Topic/Element Name": question.local_name};
          })
        },
        schema,
        function(err, result){
          if (!err) {
            that.missingField = '';
            that.validform = true;
            return;
          }
          if (/"[a-zA-Z]+"/.test(err.message)) {
            let matches = err.message.match(/"[a-zA-Z\/\s]+"/g);
            const field = matches[matches.length - 1].replace(/"/g,'').replace(/[^\/][A-Z]/g,function(match) {
              return `${match.charAt(0)} ${match.charAt(1)}`;
            }).trim();
            if (field != "Survey" && field != "Scoring Event") {
              that.missingField = field;
            } else {
              that.missingField = '';
            }
            that.validform = false;
          } else {
            that.missingField = '';
            that.validform = true;
          }
        });
    },
    submitform: function() {

      this.saving = true;
      return API.addResponsesToSurveyRun(this.surveyRun.id, this.fullsurvey.id, this.questions, this.$root.token).then(response => {
        // success callback - back to listing page
        this.saving = false;
        this.$router.push('/')
      }).catch(e => {
        console.log('API ERROR:', e)
      })
    },
    updateQuestions: function(e) {
      this.questions = e.questions;
      // validate the form when questions are updated
      this.validateForm();
    }
  }
}
</script>
<style>
.buttonbar {
  padding-top: 4em;
  padding-bottom: 4em;
}
</style>



// WEBPACK FOOTER //
// src/views/Wizard.vue